import '../scss/main.scss';

// import './libs/popper.min.js';
// import 'bootstrap';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';

import './libs/oxid/jqBootstrapValidation.min.patched.js';

import './libs/Hyphenopoly_Loader.js';

import Utils from './modules/Utils';
import HeaderHelper from './modules/HeaderHelper';
import HeaderSearch from './modules/HeaderSearch';
import HeaderNavigation from './modules/HeaderNavigation';
import HeaderMiniBasket from './modules/HeaderMiniBasket';
import HeaderLoginHelper from './modules/HeaderLoginHelper';
import HeaderEditionSelection from './modules/HeaderEditionSelection';
// import Breadcrumb from './modules/Breadcrumb';
import SearchForm from './modules/SearchForm';
import SearchResults from './modules/SearchResults';
// import CookieHintHelper from './modules/CookieHintHelper.js'
import ReviveHelper from './modules/ReviveHelper.js';
import AboModelSticky from './modules/AboModelSticky';
import WebVitalsDebugging from './modules/WebVitalsDebugging';
import { sha256, gaSetUserData } from './modules/GaSetUserData';
import SliderExpertsTile from './modules/SliderExpertsTile';

window.sha256 = sha256;
window.gaSetUserData = gaSetUserData;

window.$ = jQuery;
window.jQuery = jQuery;

new WebVitalsDebugging();

if (document.readyState != 'loading') {
    onDomReady();
} else {
    document.addEventListener('DOMContentLoaded', onDomReady);
}

function onDomReady() {


let mvgIframeApiInitialized = false;

$('#mvgFormModal').on('shown.bs.modal', function () {
    const iframe = document.getElementById('mvgFormIFrame');
    if (!iframe) {
        return;
    }

    if (!mvgIframeApiInitialized) {
        iFrameResize({
            log: false,
            checkOrigin: false
        }, '#mvgFormIFrame');

        mvgIframeApiInitialized = true;
    } else if (iframe.iFrameResizer) {
        iframe.iFrameResizer.resize();
    }
});




    function setScrollbarWidth() {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--wd-scrollbar-width', scrollbarWidth + 'px');
    }
    setScrollbarWidth();
    window.addEventListener('resize', setScrollbarWidth);
    window.addEventListener('orientationchange', setScrollbarWidth);

    new HeaderHelper();
    // new CookieHintHelper();

    if (!document.body.classList.contains('minimalLogin')) {
        window.headerSearch = new HeaderSearch();
        new HeaderNavigation();
        new HeaderMiniBasket();
        new HeaderLoginHelper();

        const dropdowns = document.querySelectorAll('.edition-dropdown-wrapper .dropdown');
        if (dropdowns.length) {
            for (const dropdown of dropdowns) {
                new HeaderEditionSelection(dropdown);
            }
        }

        // new Breadcrumb();
        new SearchForm();
        new ReviveHelper();
        new SearchResults();
    }

    var Hyphenopoly = {
        require: {
            "de": "Silbentrennungsalgorithmus"
        }
    };

    const htmlClassList = document.documentElement.classList;
    const utils = new Utils();

    if (utils.isIE())         htmlClassList.add('ie', 'ie' + utils.getInternetExplorerVersion());
    if (utils.isEdge())       htmlClassList.add('edge');
    if (utils.isGC())         htmlClassList.add('gc', 'gc' + utils.getGoogleChromeVersion());
    if (utils.isiOS())        htmlClassList.add('ios', 'ios' + utils.getiOSVersion());

    const chatbotTeaserToggle = document.querySelectorAll('#chatbotTeaserToggle');
    if (chatbotTeaserToggle.length > 0) {
        Promise.all([
            import('../scss/_chatbot.scss'),
            import('./modules/Chatbot'),
        ]).then((values) => {
            const Chatbot = values[1].default;
            new Chatbot();
        });
    }

    const newsTiles = document.querySelectorAll('.newsTilesContainer');
    if (newsTiles.length > 0) {
        Promise.all([
            import('../scss/_lineicons-pro-regular.scss'),
            import('../scss/_news-tiles.scss'),
            import('./modules/NewsTiles'),
        ]).then((values) => {
            const NewsTiles = values[2].default;
            new NewsTiles();
        });
    }

    const tables = document.getElementsByTagName('table');
    if (tables.length > 0) {
        Promise.all([
            import('./modules/TableHelper'),
        ]).then((values) => {
            const TableHelper = values[0].default;
            new TableHelper();
        });
    }

    const author = document.querySelectorAll('.toggleLinkAuthor');
    const mod = document.getElementById('authorModal');
    if (author.length > 0) {
        Promise.all([
            import('./modules/AuthorModal'),
        ]).then((values) => {
            const AuthorModal = values[0].default;
            new AuthorModal(author, mod);
        });
    }

    const whslider = document.querySelectorAll('.workhelperSliderWrapper');
    if (whslider.length > 0) {
        Promise.all([
            import('./modules/SliderWorkHelper'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/pagination'),
            import('./modules/SliderNavigationHelper')
        ]).then((values) => {
            const SliderWorkHelper = values[0].default;
            SliderWorkHelper.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].Pagination,
                values[5].default
            );

            whslider.forEach((item) => new SliderWorkHelper(item));
        });
    }

    const rtslider = document.querySelectorAll('.relatedTopicsSliderWrapper');
    if (rtslider.length > 0) {
        Promise.all([
            import('./modules/SliderRelatedTopics'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('./modules/SliderNavigationHelper')
        ]).then((values) => {
            const SliderRelatedTopics = values[0].default;
            SliderRelatedTopics.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[4].default
            );

            rtslider.forEach((item) => new SliderRelatedTopics(item));
        });
    }

    const ptslider = document.querySelectorAll('.producttipSliderWrapper');
    if (ptslider.length > 0) {
        Promise.all([
            import('./modules/SliderProductTip'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('./modules/SliderNavigationHelper')
        ]).then((values) => {
            const SliderProductTip = values[0].default;
            SliderProductTip.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[4].default
            );

            ptslider.forEach((item) => new SliderProductTip(item));

            $(document).ajaxComplete(() => {
                document
                    .querySelectorAll('.producttipSliderWrapper')
                    .forEach((item) => new SliderProductTip(item))
                ;
            });
        });
    }

    const loginInfoLayerModal = document.querySelectorAll('#loginInfoLayerModal');
    if (loginInfoLayerModal.length > 0) {
        let $loginInfoLayerModal = $(loginInfoLayerModal);
        let $body = $('body');

        $loginInfoLayerModal.css('opacity', 0.3);
        $body.append('<div class="loader" />');

        let ajaxPromise = new Promise(function(resolve, reject) {
            $loginInfoLayerModal.load(location.protocol + window.loginLayerUrl + '#loginInfoLayerModal', function() {
                $loginInfoLayerModal.css('opacity', 1);
                $body.find('.loader').remove();
                $loginInfoLayerModal.modal('show');
                resolve();
            });
        });

        Promise.all([
            import('./modules/SliderMyDownloads'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('./modules/SliderNavigationHelper'),
            ajaxPromise
        ]).then((values) => {
            const SliderMyDownloads = values[0].default;
            SliderMyDownloads.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[4].default
            );
            let myDownloadsSlider = document.querySelectorAll('.myDownloadsSliderWrapper');
            myDownloadsSlider.forEach((item) => new SliderMyDownloads(item));
        });
    }

    const seminarslider = document.querySelectorAll('.seminarSliderWrapper');
    if (seminarslider.length > 0) {
        Promise.all([
            import('./modules/SliderSeminar'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('./modules/SliderNavigationHelper')
        ]).then((values) => {
            const SliderSeminar = values[0].default;
            SliderSeminar.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[4].default
            );

            seminarslider.forEach((item) => new SliderSeminar(item));
        });
    }

    const newsSingle = document.querySelectorAll('.news-single');
    if (newsSingle.length > 0) {
        Promise.all([
            import('../scss/_news-detail.scss'),
            import('./modules/NewsDetail'),
        ]).then((values) => {
            const NewsDetails = values[1].default;
            new NewsDetails();
        });
    }

    const newsList = document.querySelectorAll('.news-list-view');
    if (newsList.length > 0) {
        Promise.all([
            import('./modules/NewsList'),
        ]).then((values) => {
            const NewsList = values[0].default;
            newsList.forEach((item) => new NewsList(item));
        });
    }

    const newsTabs = document.querySelectorAll('.newsTabsContainer');
    if (newsTabs.length > 0) {
        Promise.all([
            // import('../scss/_news-tabs.scss'), // This has been moved to preload.scss.
            import('bootstrap/js/dist/tab'),
            import('./modules/NewsTabs'),
        ]).then((values) => {
            // Show first tab
            $(newsTabs).find('.nav-tabs a:first').tab('show');

            const NewsTabs = values[1].default;
            window.newsTabs = new NewsTabs();
        });
    }

    const newsLists = document.querySelectorAll('.newsListContainer');
    if (newsLists.length > 0) {
        Promise.all([
            import('../scss/_news-list.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const aToZListContainer = document.querySelectorAll('.aToZListContainer');
    if (aToZListContainer.length > 0) {
        Promise.all([
            import('../scss/_news-atoz.scss'),
            import('./modules/NewsAToZ'),
        ]).then((values) => {
            const NewsAToZ = values[1].default;
            aToZListContainer.forEach((item) => new NewsAToZ(item));
        });
    }

    // const accountDashboard = document.querySelectorAll('.accountDashboardView');
    // if (accountDashboard.length > 0) {
    //     Promise.all([
    //         import('../scss/_account.scss'),
    //     ]).then((values) => {
    //         // Nothing todo here...
    //     });
    // }

    // const myAccount = document.querySelectorAll('.cl-forgotpwd, .cl-account_password, .accountLoginView');
    // if (myAccount.length > 0) {
    //     Promise.all([
    //         // import('../scss/_account.scss'),
    //         // import('../scss/_forms.scss')
    //     ]).then((values) => {
    //         // Nothing todo here...
    //     });
    // }

    const expertModalToggle = document.querySelectorAll('.expertModalToggler');
    // const expertModal = document.querySelectorAll('#expertModal');
    const expertModal = document.getElementById('expertModal');
    if (expertModalToggle.length > 0) {
        Promise.all([
            import('../scss/_experts-and-consultants.scss'),
            import('./modules/ExpertModal'),
            // import('./modules/AuthorModal'),
            import('../scss/_news-list.scss'),
        ]).then((values) => {
            const ExpertModal = values[1].default;
            // const AuthorModal = values[2].default;
            new ExpertModal();
            // new AuthorModal(expertModalToggle, expertModal);
        });
    }

    const webinarsModalToggler = document.querySelectorAll('.webinarsModalToggler');
    const webinarsModal = document.getElementById('webinarsModal');
    if (webinarsModalToggler.length > 0 && webinarsModal) {
        Promise.all([
            import('../scss/_webinarsmodal.scss'),
            import('../scss/_article-list.scss'),
            import('./modules/WebinarsModal'),
        ]).then((values) => {
            const WebinarsModal = values[2].default;
            new WebinarsModal();
        });
    }

    const cooperationitem = document.querySelectorAll('.cooperationitem');
    if (cooperationitem.length > 0) {
        Promise.all([
            import('../scss/_experts-and-consultants.scss'),
            import('../scss/_news-list.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const expertsTileSlider = document.querySelectorAll('.expertTeaserSlideSwiperWrapper');
    if (expertsTileSlider.length > 0) {
        Promise.all([
            import('./modules/SliderExpertsTile'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/pagination'),
            import('./modules/SliderNavigationHelper'),
            import('swiper/scss/grid'),
        ]).then((values) => {
            const SliderExpertsTile = values[0].default;
            SliderExpertsTile.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].Pagination,
                values[1].Grid,
                values[5].default
            );

            expertsTileSlider.forEach((item) => new SliderExpertsTile(item));
        });
    }

    const fullwidthSlider = document.querySelectorAll('.fullwidthTeaserSliderWrapper');
    if (fullwidthSlider.length > 0) {
        Promise.all([
            import('./modules/SliderFullwidth'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/pagination'),
            import('./modules/SliderNavigationHelper'),
            import('../scss/_fullwidth-slider.scss'),
            import('swiper/scss/autoplay'),
        ]).then((values) => {
            const SliderFullwidth = values[0].default;
            SliderFullwidth.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].Pagination,
                values[1].Autoplay,
                values[5].default
            );

            fullwidthSlider.forEach((item) => new SliderFullwidth(item));
        });
    }

    const textWithIconAboveContainer = document.querySelectorAll('.textWithIconAboveContainer');
    if (textWithIconAboveContainer.length > 0) {
        Promise.all([
            import('../scss/_lineicons-pro-regular.scss'),
            // import('../scss/_text-with-icon-above.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const rootlineContainerWrap = document.querySelectorAll('.rootlineContainerWrap');
    if (rootlineContainerWrap.length > 0) {
        Promise.all([
            import('../scss/_experts-and-consultants.scss'),
            import('./modules/Breadcrumb'),
        ]).then((values) => {
            const Breadcrumb = values[1].default;
            new Breadcrumb();
        });
    }

    // const wplusOptionsContainer = document.querySelectorAll('.wplusOptionsContainer');
    // if (wplusOptionsContainer.length > 0) {
    //     Promise.all([
    //         import('../scss/_servicebox.scss'),
    //     ]).then((values) => {
    //         // Nothing todo here...
    //     });
    // }

    const relatedCategoriesContainer = document.querySelectorAll('.relatedCategoriesContainer');
    if (relatedCategoriesContainer.length > 0) {
        Promise.all([
            import('../scss/_related-categories.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const myDownloadsSliderWrapper = document.querySelectorAll('.myDownloadsSliderWrapper');
    if (myDownloadsSliderWrapper.length > 0) {
        Promise.all([
            import('./modules/SliderMyDownloads'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('./modules/SliderNavigationHelper'),
        ]).then((values) => {
            const SliderMyDownloads = values[0].default;
            SliderMyDownloads.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[4].default
            );
            myDownloadsSliderWrapper.forEach((item) => new SliderMyDownloads(item));
        });
    }

    const contactElementContainer = document.querySelectorAll('.contactElementContainer');
    if (contactElementContainer.length > 0) {
        Promise.all([
            import('../scss/_contact-element.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const twoColumnTeaserWithColoredBackgroundContainer = document.querySelectorAll('.twoColumnTeaserWithColoredBackgroundContainer');
    if (twoColumnTeaserWithColoredBackgroundContainer.length > 0) {
        Promise.all([
            import('../scss/_two-column-teaser-with-colored-background.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const stageSliderWrapper = document.querySelectorAll('.stageSliderWrapper');
    if (stageSliderWrapper.length > 0) {
        Promise.all([
            import('./modules/SliderStage'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/pagination'),
            import('../scss/_stage-slider.scss'),
            import('swiper/scss/effect-creative'),
        ]).then((values) => {
            const SliderStage = values[0].default;
            SliderStage.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].Pagination,
                values[1].EffectCreative,
                values[5].default
            );

            stageSliderWrapper.forEach((item) => new SliderStage(item));
        });
    }

    const roundImageWithTextContainer = document.querySelectorAll('.roundImageWithTextContainer');
    if (roundImageWithTextContainer.length > 0) {
        Promise.all([
            import('../scss/_round-image-with-text.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const productInformationContainer = document.querySelectorAll('.productInformationContainer');
    if (productInformationContainer.length > 0) {
        let variants = document.getElementById('variants');
        Promise.all([
            import('../scss/_product-detail.scss'),
            import('./libs/oxid/oxajax.js'),
            import('./libs/oxid/oxarticlevariant.js'),
            import('./libs/oxid/oxrating.js'),
            import('./libs/oxid/oxreview.js'),
            import('./modules/ProductDetail'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/thumbs'),
            import('swiper/scss/free-mode'),
            import('./libs/easyzoom.js'),
            import('../scss/_easyzoom.scss'),
            import('bootstrap/js/dist/tab'),
        ]).then((values) => {
            $(variants).oxArticleVariant();

            const ProductDetail = values[5].default;
            ProductDetail.inject(
                values[6].Swiper,
                values[6].Navigation,
                values[6].Thumbs,
            );

            new ProductDetail();

            $(document).ready(function() {
                $('.productInformationContainer').each(function() {
                    var container = $(this).find('#productTitle');
                    var text = $(this).find('#productTitle span');
                    if(text.width() > container.width()) {
                        $(this).find('#productTitle').css('hyphens', 'auto');
                    }
                });
            });
        });
    }


    // const contentnavOverlayContainer = document.getElementById('contentnavOverlayContainer');
    // if (contentnavOverlayContainer) {
    //     Promise.all([
    //         import('./modules/ContentNavigation'),
    //         import('../scss/_content-nav.scss'),
    //         import('swiper'),
    //         import('swiper/scss'),
    //         import('swiper/scss/pagination'),
    //     ]).then((values) => {
    //         const ContentNavigation = values[0].default;

    //         ContentNavigation.inject(
    //             values[2].Swiper,
    //             values[2].Pagination,
    //         );

    //         new ContentNavigation();
    //     });
    // }

    // const ratingContainer = document.querySelectorAll('.ratingContainer');
    // if (ratingContainer.length > 0) {
    //     Promise.all([
    //         import('../scss/_rating.scss'),
    //     ]).then((values) => {
    //         // Nothing todo here...
    //     });
    // }

    const checkoutContainer = document.querySelectorAll('body.page-shoppingbasket');
    if (checkoutContainer.length > 0) {
        Promise.all([
            import('./modules/Checkout'),
            // import('../scss/_checkout.scss')
        ]).then((values) => {
            const Checkout = values[0].default;
            new Checkout();
        });
    }

    const basketContainer = document.querySelectorAll('body.cl-basket');
    if (basketContainer.length > 0) {
        Promise.all([
            import('./libs/oxid/oxremovebasketitems.js'),
        ]).then((values) => {
            $('.removeBasketItems').oxRemoveBasketItems();
        });
    }

    const userContainer = document.querySelectorAll('body.cl-user, body.cl-register, body.cl-register_myevents');
    if (userContainer.length > 0) {
        Promise.all([
            import('./modules/Checkout'),
            // import('../scss/_checkout.scss'),
            import('./libs/oxid/wesvalidateaddresstype.js'),
            import('./libs/oxid/oxusershipingaddressselect.js'),
            import('./libs/oxid/oxselectbox.js'),
            // import('./libs/oxid/oxpayment.min.js')
        ]).then((values) => {
            $('form.js-oxValidate').wesValidateAddressType({formType:'Billing'});
            $('form.js-oxValidate').wesValidateAddressType({formType:'Shipping'});
            $('input[name="oxaddressid"]').oxUserShipingAddressSelect();
            $('.form select').oxSelectBox();
            // $('#payment').oxPayment();
            $('#payment input, #payment select, #payment textarea').not('[type=submit]').jqBootstrapValidation();
            const Checkout = values[0].default;
            new Checkout();
        });
    }

    const articleList = document.querySelectorAll('.articleList');
    if (articleList.length > 0) {
        Promise.all([
            import('./modules/ArticleList'),
            import('../scss/_article-list.scss')
        ]).then((values) => {
            const ArticleList = values[0].default;
            articleList.forEach((item) => new ArticleList(item));
        });
    }

    const categoryAttributeFilters = document.querySelectorAll('.subcategoriesAndFilterContainer .filters');
    if (categoryAttributeFilters.length > 0) {
        Promise.all([
            import('./modules/CategoryAttributeFilters'),
            import('./modules/ArticleList'),
        ]).then((values) => {
            const CategoryAttributeFilters = values[0].default;

            CategoryAttributeFilters.inject(
                values[1].default,
            );

            new CategoryAttributeFilters();
        });
    }

    const categoryFilters = document.querySelectorAll('.categoriesAndFilterContainer .filters');
    if (categoryFilters.length > 0) {
        Promise.all([
            import('./modules/CategoryFilters'),
        ]).then((values) => {
            const CategoryFilters = values[0].default;
            new CategoryFilters();
        });
    }

    const categoryAndSubcategoryFilters = document.querySelectorAll('.categoriesAndSubcategoriesFilterContainer .filters');
    if (categoryAndSubcategoryFilters.length > 0) {
        Promise.all([
            import('./modules/CategorySubcategoryFilters'),
            // import('./modules/ArticleListLandingPage'),
            import('./modules/ArticleList'),
        ]).then((values) => {
            const CategorySubcategoryFilters = values[0].default;
            CategorySubcategoryFilters.inject(
                values[1].default,
            );
            new CategorySubcategoryFilters();
        });
    }

    const twoColumnTeaserContainer = document.querySelectorAll('.two-column-teaser-container');
    if (twoColumnTeaserContainer.length > 0) {
        Promise.all([
            import('../scss/_landing-page.scss')
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const aboSlider = document.querySelectorAll('.aboModelSwiper');
    if (aboSlider.length > 0) {
        Promise.all([
            import('./modules/AboModelSlider'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('../scss/_sticky_elements.scss')
        ]).then((values) => {
            const AboModelSlider = values[0].default;
            AboModelSlider.inject(
                values[1].Swiper,
                values[1].Navigation,
            );
            // aboSlider.forEach((item) => new AboModelSlider(item));
            var sliders = [];
            aboSlider.forEach(function(item) {
                sliders.push(new AboModelSlider(item));
            });

            new AboModelSticky(sliders);

            /*
            sliders.forEach(function(item) {
                console.log('ai:' + item.swiper.activeIndex);
            });
            */

            /*
            if (window.location.href.includes('test-weka')) {
                Promise.all([
                    import('../scss/_sticky_elements.scss')
                ]).then((values) => {
                    new AboModelSticky();
                });
            } */
        });
    }

    const newAboSliders = document.querySelectorAll('.newAboModelSwiper');

    if (newAboSliders.length > 1) {
        newAboSliders.forEach(slider => {
            const submitButtons = slider.querySelectorAll('.submitButton');
            submitButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    if(e.currentTarget.closest('.swiper-slide').classList.contains('disabled')) {
                        e.preventDefault();
                        return;
                    }

                    const active = e.currentTarget.
                        closest('.content').
                        querySelector('.monthVariant.active');

                    if(active) {
                        location = location.origin + '?fnc=redirectordersubscription&ano=' + active.dataset.artno;
                    }
                });
            });

            const lists = slider.querySelectorAll('.checklistContainer > ul');
            lists.forEach(ul => {
                // de
                ul.innerHTML = ul.innerHTML.replace(
                    /CHF\s+(\d+)\.00\b/,
                    'CHF <span class="voucher-value">$1</span>.00'
                );
                // fr
                ul.innerHTML = ul.innerHTML.replace(
                    /(\d+(?:[’' ]\d{3})*(?:[.,]\d{2})?)\s*CHF\b/,
                    '<span class="voucher-value">$1</span> CHF'
                );
            });
        });

        const uniqueArtnos = [
            ...new Set(
                Array.from(document.querySelectorAll('[data-parent-artno]'))
                    .map(el => el.getAttribute('data-parent-artno'))
                    .filter(Boolean)
            )
        ];

        uniqueArtnos.forEach(artno => {
            const elements = document.querySelectorAll('[data-parent-artno="' + artno + '"]');

            if (elements.length != 2) {
                return;
            }

            const [el1, el2] = elements;

            [el1, el2].forEach(el => {
                const buttons = el.querySelectorAll('.monthVariants button');

                if (buttons.length < 1) {
                    return;
                }

                updateElement(el, buttons[buttons.length - 1]);

                buttons.forEach(button => {
                    button.addEventListener('mouseover', (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        [el1, el2].forEach(el => {
                            updateElement(el, button);
                        });
                    });
                });
            });
        });


        function updateElement(el, button) {
            el.querySelectorAll('.monthVariants button').forEach(btn => {
                if(button.dataset.artno == btn.dataset.artno) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });

            const price = button.dataset.price;
            const monthlyPrice = button.dataset.shortdesc;
            const billingInfo = button.dataset.meddesc;
            const voucherValue = button.dataset.voucher;

            const medDesc = el.querySelector('.medDesc');
            // medDesc.style.height = 'auto';
            medDesc.innerHTML = '<span>' + billingInfo + '</span>';

            updateVoucher(el, voucherValue);

            el.querySelector('h3.price').textContent = monthlyPrice;

        //     /// ---
        //    const medDescriptions = document.querySelectorAll('.medDesc');
        //     //const spans = document.querySelectorAll('.medDesc span');
        //     let isMultiLine = false;

        //     medDescriptions.forEach(el => {
        //         if(el.querySelector('br')) {
        //             isMultiLine = true;
        //         }
        //         // console.log(el.querySelector('br'));
        //         // console.log(el);
        //         // console.log(el.getClientRects().length > 1);
        //         // console.log(el.scrollHeight > el.clientHeight);

        //         // const span = el.querySelector('span');
        //         // console.log(span);
        //         // if (isMultiLine(el))
        //         //     isMultiLinex = true;
        //     });

        //     console.log('isMultiline: ' + isMultiLine);
        //     /// ---

            // const medDescriptions = document.querySelectorAll('.medDesc');

            // let maxHeight = 0;
            // medDescriptions.forEach(el => {
            //     const h = el.offsetHeight;
            //     console.log('se height: ' + el.offsetHeight);
            //     if (h > maxHeight) {
            //         maxHeight = h;
            //     }
            // });
            // medDescriptions.forEach(el => {
            //     el.style.height = maxHeight + 'px';
            // });

            // if(maxHeight > 40) {
            //     newAboSliders.forEach(slider => {
            //         slider.querySelectorAll('.swiper-slide').forEach(slide => slide.classList.add('hasUpgrade'));
            //     });
            // }

        }

        function updateVoucher(el, value) {
            const voucherTextSpan1 = el.querySelector('.voucherContainer .voucher-value');
            const voucherTextSpan2 = el.querySelector('.checklistContainer .voucher-value');
            const oldValue = parseInt(voucherTextSpan1.textContent) || 0;
            const newValue = value;

            animateValue(voucherTextSpan1, voucherTextSpan2, oldValue, newValue, 400);
        }

        function animateValue(el1, el2, start, end, duration) {
            const range = end - start;
            const startTime = performance.now();

            function update(currentTime) {
                const progress = Math.min((currentTime - startTime) / duration, 1);
                const value = Math.round(start + range * progress);
                el1.textContent = value;
                el2.textContent = value;

                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            }

            requestAnimationFrame(update);
        }
    }

    // const downloadContainer = document.querySelectorAll('.myAccountDownloadContainer');
    // if(downloadContainer.length > 0) {
    //     Promise.all([
    //         // import('../scss/_account.scss'),
    //         // import('../scss/_downloads.scss')
    //     ]).then((values) => {
    //         // Nothing todo here...
    //     });
    // }

    const seminareLinkContainer = document.querySelectorAll('.cl-account_subscriptions, .cl-account_order, .cl-account_user, .accountMyEventsSeminareLinkContainer');
    if (seminareLinkContainer.length > 0) {
        Promise.all([
            import('./modules/Checkout'),
            // import('../scss/_account.scss'),
            // import('../scss/_checkout.scss'),
            import('./libs/oxid/wesvalidateaddresstype.js'),
            import('./libs/oxid/oxusershipingaddressselect.js')
        ]).then((values) => {
            const Checkout = values[0].default;
            new Checkout();
            $('form.js-oxValidate').wesValidateAddressType({formType:'Shipping'});
            $('form.js-oxValidate').wesValidateAddressType({formType:'Billing'});
            $('input[name="oxaddressid"]').oxUserShipingAddressSelect();
        });
    }

    const thankYou = document.querySelectorAll('body.cl-thankyou');
    if (thankYou.length > 0) {
        Promise.all([
            import('../scss/_upselling.scss')
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const ordersList = document.querySelectorAll('.ordersList');
    if (ordersList.length > 0) {
        Promise.all([
            import('./modules/OrdersList')
        ]).then((values) => {
            const OrdersList = values[0].default;
            ordersList.forEach((item) => new OrdersList(item));
        });
    }

    const videoGeContainer = document.querySelectorAll('.videoGeContainer');
    if (videoGeContainer.length > 0) {
        Promise.all([
            import('../scss/_video.scss'),
        ]).then((values) => {
            // Nothing todo here...
        });
    }

    const hlsVideos = document.querySelectorAll('video[data-hls-video]');
    if (hlsVideos.length > 0) {
        Promise.all([
            import('./modules/HlsVideoPlayer'),
            import('plyr/src/sass/plyr.scss'),
            import('../scss/_plyr.scss'),
        ]).then((values) => {
            const HlsVideoPlayer = values[0].default;
            hlsVideos.forEach((item) => new HlsVideoPlayer(item));
        });
    }

    const tagList = document.querySelectorAll('#maincategoryTagList[data-slider-on-mobile]');
    if (tagList.length > 0) {
        Promise.all([
            import('./modules/MainCategoryTagListSlider'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
        ]).then((values) => {
            const MainCategoryTagListSlider = values[0].default;
            MainCategoryTagListSlider.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].FreeMode
            );

            tagList.forEach((item) => new MainCategoryTagListSlider(item));
        });
    }

    const solr = document.querySelectorAll('.tx_solr');
    if (solr.length > 0) {
        $('#content').addClass('solr');
    }

    $(document.body).on('click', '#c22348 a, #c22367 a, #c22804 a, #c22826 a ', (e) => {
        e.preventDefault();

        $('#contactModal').modal('toggle');
    });

    if (window.location.hash.toLowerCase() == '#contactmodal') {
        $('#contactModal').modal('toggle');
    }
    if (window.location.hash.toLowerCase() == '#newslettermodal') {
        $('#newsletterModal').modal('toggle');
    }

    $('.newsVideoPreview .playButton').on('click', function () {
        $('.toContinueWatchingModal').removeClass('hidden');
    });

    const threeColumnTextTeaserSwiper = document.querySelectorAll('.threeColumnTextTeaserSwiper');
    if (threeColumnTextTeaserSwiper.length > 0) {
        Promise.all([
            import('./modules/ThreeColumnTextTeaserSwiper'),
            import('swiper'),
            import('swiper/scss'),
            import('swiper/scss/navigation'),
            import('swiper/scss/pagination'),
            import('./modules/SliderNavigationHelper')
        ]).then((values) => {
            const ThreeColumnTextTeaserSwiper = values[0].default;
            ThreeColumnTextTeaserSwiper.inject(
                values[1].Swiper,
                values[1].Navigation,
                values[1].Pagination,
                values[5].default
            );
            threeColumnTextTeaserSwiper.forEach((item) => new ThreeColumnTextTeaserSwiper(item));
        });
    }
}